import React from 'react'
import { Link, Toast } from 'ui'
import { useAuth } from '@hooks/useAuth'
import styles from '@styles/components/PrivateBetaSurveyToast.module.scss'
import {
  LocalStorageBooleanValue,
  LocalStorageKey
} from '@constants/localStorage'
import { useTranslations } from 'use-intl'

const PrivateBetaSurveyToast = () => {
  const { showPrivateBetaSurveyToast, setShowPrivateBetaSurveyToast } =
    useAuth()

  const t = useTranslations()

  function handleClose() {
    setShowPrivateBetaSurveyToast(false)
  }

  function openSurveyLink(e: React.MouseEvent<HTMLElement, MouseEvent>) {
    localStorage.setItem(
      LocalStorageKey.privateBetaHasViewedSurveyMessage,
      LocalStorageBooleanValue.TRUE
    )

    // Close the toast when the survey link is opened
    e.currentTarget.dispatchEvent(
      new Event('close', { bubbles: true, composed: true })
    )
  }

  return (
    <Toast
      variant="info"
      className={styles['toast']}
      close={handleClose}
      open={showPrivateBetaSurveyToast}>
      {t.rich('dashboard:privateBetaSurvey:text', {
        hyperlinked: chunks => (
          <Link
            href={t('dashboard:privateBetaSurvey:url')}
            target="_blank"
            static="white"
            onClick={openSurveyLink}>
            {chunks}
          </Link>
        )
      })}
    </Toast>
  )
}

export default PrivateBetaSurveyToast
